// Package Imports 
import Template from '../components/template.js';

// CSS Imports
import '../styles/automatic_calculator.css';

// Asset Imports
import logo from '../assets/images/logo.svg';

function AutomaticCalculator() {
    const handleFileUpload = (selectedFile) => {
        // Logic to handle the uploaded file
        console.log('Uploaded file:', selectedFile);
        // You can perform further actions here, like sending the file to a server or processing it.
    };

    const handleClick = () => {
        const fileUpload = document.getElementById('fileUpload');
        fileUpload.click();
    };

    const handleChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            // Do something with the selected file, like uploading it
            handleFileUpload(selectedFile);
        }
    };

    return (
        <div>
            <Template />
            <input
                type="file"
                accept=".pdf"
                onChange={handleChange}
                style={{ display: 'none' }}
                id="fileUpload"
            />
            <button className="upload-button" onClick={handleClick}>
                <TopContainer />
                <BottomContainer />
            </button>
        </div>
    );
}

function TopContainer() {
    return (
        <div className="top-container">
            <img src={logo} alt="button icon" className="upload-icon"/>
        </div>
    );
}

function BottomContainer() {
    return (
        <div className="bottom-container">
        </div>
    );
}

export default AutomaticCalculator;
